import { CheckCircle2 } from "lucide-react";
import { STEP_LABELS } from "./helpers";

export default function ProgressBar({ step }) {
  return (
    <div className="flex items-center gap-2 sm:gap-4 max-w-2xl mx-auto">
      {STEP_LABELS.map((label, i) => {
        const idx = i + 1;
        const active = idx === step;
        const done = idx < step;
        return (
          <div key={label} className="flex items-center flex-1">
            <div
              data-testid={`progress-step-${idx}`}
              className={`flex items-center gap-2 ${i === 0 ? "" : "ml-1"}`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center font-mono text-[13px] font-semibold transition-colors ${
                  done
                    ? "bg-oc-fair text-white"
                    : active
                    ? "bg-oc-primary text-white"
                    : "bg-white border border-oc-border text-oc-textSecondary"
                }`}
              >
                {done ? <CheckCircle2 className="w-4 h-4" /> : idx}
              </div>
              <span
                className={`hidden sm:block text-[13px] font-medium ${
                  active ? "text-oc-primary" : "text-oc-textSecondary"
                }`}
              >
                {label}
              </span>
            </div>
            {i < STEP_LABELS.length - 1 && (
              <div className={`h-px flex-1 mx-2 ${done ? "bg-oc-fair" : "bg-oc-border"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export function StepHeader({ children, sub }) {
  return (
    <div className="text-center max-w-2xl mx-auto">
      <h1 className="font-display font-bold text-[34px] sm:text-[44px] leading-tight tracking-tight text-oc-primary">
        {children}
      </h1>
      {sub && <p className="mt-3 text-oc-textSecondary text-[17px] leading-relaxed">{sub}</p>}
    </div>
  );
}
